import accountData from './account-data'
import email from './email'
import image from './image'
import language from './language'
import password from './password'

export default {
    accountData,
    email,
    image,
    language,
    password
}
